module.exports = __webpack_public_path__ + "img/eco-saliva-qr-code.16561a5e.jpg";